import { Form } from 'react-bootstrap';

/**
 * The standard Fusion text input field.
 * @param {{children: Component | Component[], style?: Object, disabled?: boolean, label?: string, className?: string, required?: boolean, controlId?: string}}
 * @returns A react component
 */
export default function FusionCustomInput({
  children,
  style,
  disabled = false,
  label = '',
  className,
  fullWidth = false,
  required = false,
  controlId,
}) {
  return (
    <Form.Group controlId={controlId} className={fullWidth ? 'w-100' : undefined}>
      {label && (
        <Form.Label className="fs-6">
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </Form.Label>
      )}
      <div
        className={`fusion-input text-white ${className || ''}`}
        style={{
          '--color': disabled ? 'grey' : '#325277',
          ...style,
        }}
      >
        {children}
      </div>
    </Form.Group>
  );
}
